module.exports = __webpack_public_path__ + "static/media/35.54b72e44.jpg";